/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';

// import {
//   useSelector, // useDispatch
// } from 'react-redux';
//import { useParams } from 'react-router-dom';
import { dispatch } from 'src/store';

import Preview from './Preview';
import Config from './Config';
import { convertDataFromReduxToServer } from './tools';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';

import RouteBlock from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/RouteBlock';
import { handleOnGetCurrentSCTimezoneUTC } from 'src/tools/tools';

import {
  request_tabBar,
  request_saveTabBar,
  getSalesChannelContent,
  getSalesChannelName,
  getHasModified,
  // getTimeZone,
  getState,
  validation,
  getLoaded,
} from './slice';

import styles from './style.module.less';
import { Spin } from 'antd';

// interface IParams {
//   contentUuid: string;
//   saleChannelUuid: string;
// }

function SalesChangeEditorTabBar(props) {
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    loaded,
    //isOnPrimaryLanguage,
  } = props;
  //const _d = useDispatch();
  // const timeZone = useSelector(getTimeZone());
  const scTimezoneUTC = handleOnGetCurrentSCTimezoneUTC();

  //  const loading = useSelector(getLoading());

  //const _params: IParams = useParams();

  ///===== //To Do Delete Link Temp=====
  // const [loaded] = React.useState(true);
  ///===== //To Do Delete Link Temp=====

  //const { contentUuid } = _params;
  console.log(loaded);
  React.useEffect(() => {
    // _d(
    //   request_tabBar({
    //     uuid: contentUuid,
    //   }),
    // );
  }, []);

  const renderTitle = () => {
    return (
      <>
        <span>Tab Bar</span>
        <div
          className={styles.timezone}>{`Time Zone (UTC ${scTimezoneUTC})`}</div>
      </>
    );
  };

  return (
    <React.Fragment>
      <RouteBlock getHasModified={getHasModified} />
      <PageWrapper
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName,
          onDiscard,
          onGoBack,
        }}
        leftChild={
          <div className={styles.left}>
            <Spin spinning={!loaded}>
              <Preview />
            </Spin>
          </div>
        }
        rightChild={
          loaded ? (
            <RightConfigWrapper
              title={renderTitle()}
              elements={[
                {
                  body: <Config />,
                  key: 'TabBarSetting',
                },
              ]}
            />
          ) : null
        }
      />
    </React.Fragment>
  );
}

export default BasicPageHOC(SalesChangeEditorTabBar, {
  getState,
  convertDataFromReduxToServer,
  submit: request_saveTabBar,
  getHasModified,
  getSalesChannel: getSalesChannelContent,
  getSalesChannelName: getSalesChannelName,
  validation,
  getLoaded,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      request_tabBar({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
